<script>
  import { createEventDispatcher } from 'svelte';

  export let image
  export let clickable = false
  export let overlay = ''

  const dispatch = createEventDispatcher()

  function onClick(event) {
    dispatch('click', event);
  }
</script>

<div class="container" on:click={onClick} >
  <img src={image.src} alt={image.alt} class:clickable />
  {#if overlay}
    <div class="overlay">
      {overlay}
    </div>
  {/if}
</div>

<style>
.container {
  position: relative;
  width: 100%;
  height: 100%;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: var(--border-width) solid transparent;
  border-radius: var(--border-radius-xs);
  background-color: var(--color-grey-light);
}

img.clickable {
  cursor: pointer;
}

img.clickable:hover {
  border: var(--border-width) solid var(--color-black);
}

.overlay {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;

  background: var(--color-black);
  color: var(--color-white);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  opacity: var(--opacity-mid);
  border-radius: var(--border-radius-xs);

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.overlay:hover {
  opacity: var(--opacity-dark);
}
</style>
